// General
import React, { Component } from 'react';

// Style
import { Grid, Row, Col } from 'react-bootstrap';

// Component
import Input from '../common/FormComponents/InputStyle';

// Helpers
import InputHeader from '../common/FormComponents/InputHeader';
import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace } from '../common';
import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import styled from 'styled-components';
import { colors } from './../../tailwind';
import Select from './Select';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import { FILTER_CATEGORIES } from '../../components/siteadmin/BulkListings/BulkListingsStore';
import _ from 'lodash';

@observer
class Description extends Component {
  render() {
    const { store, nextPage } = this.props;

    const visited = store.groupsVisited.description;

    const categoryOptions = _.map(FILTER_CATEGORIES, (value, key) => {
      return (
        <option value={key} key={'cat' + key}>
          {value}
        </option>
      );
    });

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={7} md={7} lg={7}>
            <StepHeaderBlock
              stepNumber="1"
              headerText="Great! Now let’s describe your item."
            />
            <Whitespace smaller />

            <InputHeader
              label=""
              error={(visited && store.fieldErrors('title')) || ''}
            />
            <Input
              onChange={e => (store.title = e.target.value)}
              value={store.title}
              placeholder="Title"
              name="title"
            />

            <Whitespace smaller />

            <InputHeader
              label=""
              error={(visited && store.fieldErrors('description')) || ''}
            />
            <TextArea
              onChange={e => (store.description = e.target.value)}
              value={store.description}
              placeholder="Enter Description here..."
              name="description"
            />

            <Whitespace smaller />

            <InputHeader
              label="Pick a category"
              error={(visited && store.fieldErrors('categories')) || ''}
            />
            <Select
              form="ListingForm"
              name="category"
              onChange={e => store.addSingleCategory(e.target.value)}
              value={store.firstCategory}
            >
              <option value="" />
              {categoryOptions}
            </Select>

            <Whitespace smaller />

            <InputHeader label="Second category (optional)" />
            <Select
              form="ListingForm"
              name="category2"
              onChange={e => store.addSecondCategory(e.target.value)}
              value={store.secondCategory}
            >
              <option value="" />
              {categoryOptions}
            </Select>

            <Whitespace smaller />

            <FormNav noBack nextPage={nextPage} store={store} />
          </Col>
          <Col>
            <ListPlaceTips
              tips={[
                {
                  title: 'Title',
                  tips: [
                    'Be clear and concise.',
                    'Use the items make and model or other details in the title, the picture you upload later should be the attention grabber.',
                  ],
                },
                {
                  title: 'Description',
                  tips: [
                    'Whitespace and lists make your description easier to read',
                    'Make your description easily scannable',
                  ],
                },
              ]}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Description;

export const TextArea = styled.textarea`
  height: 100%;
  max-height: 100%;
  padding-top: 0;
  resize: none;
  width: 100%;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px ${colors.coolGrayLight};
  font-family: Helvetica;
  font-size: 19px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.primaryLight};
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  min-height: 100px;

  &::placeholder {
    color: ${colors.primaryFaded};
    opacity: 0.6;
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Description.js